export default __webpack_public_path__ + "static/media/mobile-background-image.253ad32b.jpg";